"use client";

import { c as _c } from "react/compiler-runtime";
import { NextIntlClientProvider } from "next-intl";
import { ReactNode } from "react";
import { useSchedulerSelector } from "@/lib/hooks/useSchedulerMachine";
// We can just statically bundle both files for now to keep it simple
import enUsMessages from "@/messages/en-us.json";
import esUsMessages from "@/messages/es-us.json";
import { Language } from "@/types/scheduler-machine";
const messagesMap: Record<Language, typeof enUsMessages> = {
  "en-us": enUsMessages,
  "es-us": esUsMessages
};
export function IntlProviderWrapper(t0) {
  const $ = _c(7);
  const {
    children
  } = t0;
  const currentLanguage = useSchedulerSelector(_temp);
  const facilityTimeZone = useSchedulerSelector(_temp2);
  let t1;
  if ($[0] !== facilityTimeZone) {
    t1 = facilityTimeZone || Intl.DateTimeFormat().resolvedOptions().timeZone || "America/Chicago";
    $[0] = facilityTimeZone;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const timeZone = t1;
  const t2 = messagesMap[currentLanguage];
  let t3;
  if ($[2] !== children || $[3] !== currentLanguage || $[4] !== t2 || $[5] !== timeZone) {
    t3 = <NextIntlClientProvider locale={currentLanguage} messages={t2} timeZone={timeZone}>{children}</NextIntlClientProvider>;
    $[2] = children;
    $[3] = currentLanguage;
    $[4] = t2;
    $[5] = timeZone;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}
function _temp2(s_0) {
  return s_0.context.facility?.location?.timeZone;
}
function _temp(s) {
  return s.context.currentLanguage;
}